import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SnowAnimationService {
  public readonly flagsLoaded$ = new BehaviorSubject<boolean>(
    localStorage.getItem('showSnowAnimation')
      ? JSON.parse(localStorage.getItem('showSnowAnimation')!)
      : false
  );

  public showSnowAnimation(): boolean {
    return this.flagsLoaded$.value;
  }

  public setShowSnowAnimation(snowAnimationValue: boolean): void {
    localStorage.setItem('showSnowAnimation', snowAnimationValue.toString());
    this.flagsLoaded$.next(snowAnimationValue);
  }
}
